import { WithdrawalExportStatus } from 'further-types/withdrawal';

export const WithdrawalExportStatusLabels = {
  [WithdrawalExportStatus.AwaitingCustodianExport]: 'Awaiting custodian export',
  [WithdrawalExportStatus.ExportedToCustodian]: 'Exported to custodian',
};
